/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, Input, OnChanges} from '@angular/core';
import * as _ from 'lodash';
import {SiteResource} from '../../../components/api/resources/resource/site.resource';

@Component({
  standalone: false,
  selector: 'adn-targeting-site-target-summary',
  template: `
    <div>
      <strong *ngIf="negated">NOT:&nbsp;</strong>
      <ng-container *ngFor="let site of displayedSites; let last = last">
        <a *ngIf="linkTargets && site?.url" uiSref="app.inv.sites.site" [uiParams]="{id: site?.id}">{{site?.name}}</a>
        <span *ngIf="!linkTargets || !site?.url">{{site?.name}}</span><span *ngIf="!last">, </span>
      </ng-container>
      <div *ngIf="restricted && isLimited"><a class="show-hide-link" (click)="liftRestriction()"><span class="fa fa-chevron-down"></span>Show all</a></div>
    </div>
  `
})
export class SiteSummaryComponent implements OnChanges {
  @Input() targets: any;
  @Input() linkTargets = false;

  negated = false;
  restricted = true;
  isLimited = false;
  displayedSites: any[] = [];
  private data: any[] = [];
  private cache: Record<string, any> = {};
  private readonly quantity = 10;

  constructor(@Inject(SiteResource) private readonly Site: any) {
  }

  ngOnChanges(): void {
    const target = this.targets || {};
    this.negated = target.negated;
    this.restricted = true;
    const hasNameAlready = !!_.get(target, 'sites[0].name');
    if (hasNameAlready) {
      this.data = target.sites;
      this.updateDisplay();
    } else {
      const siteIds = _.get(target, 'sites[0].id') ? _.map(target.sites, 'id') : target.sites;
      const queryIds = _.without(siteIds, ...Object.keys(this.cache));
      if (queryIds.length === 0) {
        this.data = _.map(siteIds, (id) => this.cache[id]);
        this.updateDisplay();
        return;
      }
      this.Site.query(queryIds, (page) => {
        _.forEach(page.results, (s) => {
          this.cache[s.id] = s;
        });
        this.data = _.map(siteIds, (id) => this.cache[id]);
        this.updateDisplay();
      });
    }
  }

  liftRestriction(): void {
    this.restricted = false;
    this.updateDisplay();
  }

  private updateDisplay(): void {
    this.displayedSites = this.restricted ? this.data.slice(0, this.quantity) : this.data;
    this.isLimited = this.data.length > this.quantity;
  }
}
